import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Alert } from '@availity/element';
import MessageStore from '../../stores/MessageStore';

const Message = observer(({ messageStore }) => {
  const { messages, showMessage } = messageStore;

  return showMessage && (
    messages.map((messageObj) => (
      <Alert
        sx={{ mb: 2 }}
        key={`${messageObj.message}id`}
        severity={messageObj.messageType}
      >
        <span>{messageObj.message}</span>
      </Alert>
    ))
  );
});

Message.propTypes = {
  messageStore: PropTypes.instanceOf(MessageStore).isRequired,
};

export default Message;
